import summary from "../../api/contactSummary";
import { percentageVieW, dummyRows, convertCount } from "@/common/functions";
const getDefaultState = () => {
  return {
    report: [],
    count: 0,
    loaded: false,
    busyLoader: false,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getReport: (state) => {
    var yammerDomains = ["Contoso.com", "Contoso.onmicrosoft.com"];
    var icloudDomains = ["@icloud.com", "@me.com", "@mac.com"];
    var atntDomains = [
      "@ameritech.net",
      "@att.net",
      "@bellsouth.net",
      "@currently.com",
      "@flash.net",
      "@nvbell.net",
      "@pacbell.net",
      "@prodigy.net",
      "@sbcglobal.net",
      "@snet.net",
      "@swbell.net",
      "@wans.net",
    ];

    if (!state.report.length && !state.loaded) {
      return dummyRows();
    }
    return state.report.map((item) => {
      var domainCategory = item.domainCategory;
      // return item
      if (domainCategory === "others") {
        if (yammerDomains.includes(domainCategory)) {
          domainCategory = "yammer";
        } else if (icloudDomains.includes(domainCategory)) {
          domainCategory = "icloud";
        } else if (atntDomains.includes(domainCategory)) {
          domainCategory = "at&t";
        }
      }

      return {
        domain: item.domain,
        totalContacts: convertCount(item.totalContacts),
        valid: convertCount(item.valid),
        bounce: convertCount(item.bounce),
        opens: convertCount(item.opens),
        click: convertCount(item.click),
        unsubs: convertCount(item.unsubs),
        abuse: convertCount(item.abuse),
        spamComplaints: convertCount(item.spamComplaints),
        unknown: convertCount(item.unknown),
        domainCategory: domainCategory,
        valid_percent: percentageVieW(item.valid, item.totalContacts) + "%",
        unknown_percent: percentageVieW(item.unknown, item.totalContacts) + "%",
        bounce_percent: percentageVieW(item.bounce, item.totalContacts) + "%",
        open_percent: percentageVieW(item.opens, item.active) + "%",
        clicks_percent: percentageVieW(item.click, item.opens) + "%",
        unsub_percent: percentageVieW(item.unsubs, item.totalContacts) + "%",
        abuse_percent: percentageVieW(item.abuse, item.totalContacts) + "%",
        spam_comp_percent:
          percentageVieW(item.spamComplaints, item.totalContacts) + "%",
      };
    });
    // }
  },
};

// actions
const actions = {
  fetchContactSummary({ commit, state }, params) {
    return new Promise(function (resolve) {
      summary.fetchContactSummary(params, (data) => {
        commit("setReport", data.details);
        commit("setCount", data.totalCount);
        commit("setLoaded", true);
        commit("setBusyLoader", true);
        resolve(data.totalCount);
      });
    });
  },
};

// mutations
const mutations = {
  setReport(state, data) {
    state.report = data;
  },
  setCount(state, data) {
    state.count = data;
  },
  setLoaded(state, status) {
    state.loaded = status;
  },
  setBusyLoader(state, status) {
    state.busyLoader = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
